export class Handle {
    // A listener callback
    constructor(type, callback) {
        // Listens for message of this type
        this.type = type;
        // Executes this callback
        this.callback = callback;
    }
}
